export default __webpack_public_path__ + "static/media/IconAngleDown.e3eb4abf.svg";